import React from "react";
import Alert from "features/shared/alerts/components/Alert";
import AlertSimplified from "features/shared/alerts/dtos/AlertSimplified";

interface Props {
  alertObject: AlertSimplified;
  closable?: boolean;
  actionBtns?: () => JSX.Element;
}

const ContentDialogAlert = ({ alertObject, closable, actionBtns }: Props) => {
  return (
    <>
      <div className="p-4">
        <Alert alertObj={alertObject} closable={closable} />
      </div>
      {actionBtns && (
        <div className="d-flex justify-content-end px-4 pb-4">
          {actionBtns()}
        </div>
      )}
    </>
  );
};

export default ContentDialogAlert;
